import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Image from '../global/Image';
import PageDataNumber from './PageDataNumber';

export default class PageHistory extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div data-id={block.id} className={'c-history c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after}>
			    
			    	<div className="l-content">
			    		
			    		<div className="l-grid l-grid--m-end">
			    		
			    			<div className="l-grid__col">
			    			
			    				<h2 className="c-paragraph c-paragraph--xlarge c-paragraph--space" dangerouslySetInnerHTML={{__html:block.heading}}></h2>
			    			
			    				<div className="c-history__text scope-text--xxxlarge scope-text--faded scope-text--no-max-width" dangerouslySetInnerHTML={{__html:block.text}}></div>
			    				
			    				{block.url &&
									<Link to={{ pathname: block.url }} className="c-history__link" dangerouslySetInnerHTML={{__html:'<span>&#x2197;&#xFE0E;</span>&nbsp;<span>View more</span>'}}></Link>
													
								}
								
							</div>
							
							<div className="l-grid__col l-grid__col--m-6-12">
								
								<div className="c-history__image">
			    					
			    					<Image src={block.src} srcset={block.srcset} width={block.width} height={block.height}></Image>
			    					
			    				</div>
			    				
			    			</div>
			    		
			    			<div className="l-grid__col l-grid__col--m-6-12">
			    						    			
								<div className="c-data">
			    				
				    				{block.data && block.label &&
				    					<div className="c-data__block">
				    						<PageDataNumber prepend={block.data_prepend} data={block.data} append={block.data_append}></PageDataNumber>
				    						<p className="c-data__label" dangerouslySetInnerHTML={{__html:block.label}}></p>
				    					</div>
				    				}
				    				
				    			</div>
								
							</div>
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
